import PressRelease from './press_release';
export default PressRelease;
